//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular, { ILogService, ITimeoutService } from 'angular';
import { IStateService } from 'angular-ui-router';

import { IAmplifyService } from '@services/amplify-service';
import { SessionVarsService as TSessionVarsService } from '@services/session-vars-service';

import template from 'app/components/settings-menu/settings-menu.html';
import { GaApi } from 'app/initialization/ga/ga-api';

angular.module('curalate').component('settingsMenu', {
  template,
  controller: [
    '$log',
    '$state',
    '$timeout',
    'AmplifyService',
    'SessionVarsService',
    'TrackingService',
    function (
      this: any,
      $log: ILogService,
      $state: IStateService,
      $timeout: ITimeoutService,
      AmplifyService: IAmplifyService,
      SessionVarsService: TSessionVarsService,
      TrackingService: GaApi,
    ) {
      this.$onInit = () => {
        const firstName = SessionVarsService.getUser().firstName;
        const lastName = SessionVarsService.getUser().lastName;
        this.firstName = firstName;
        this.lastName = lastName;
        this.initials = firstName.charAt(0) + lastName.charAt(0);
        this.gravatarHash = SessionVarsService.getEmailMD5Hash();

        this.opened = false;
        this.closeTimeout = null;
      };

      this.onDropdownMouseenter = () => {
        this.opened = true;

        if (this.closeTimeout) {
          $timeout.cancel(this.closeTimeout);
          this.closeTimeout = null;
        }

        this.settingsMenuViewedTimeout = $timeout(() => {
          TrackingService.recordEvent(
            TrackingService.CATEGORY_NAVIGATION3,
            TrackingService.ACTION_NAVIGATION3_SETTINGS_HOVER,
          );
        }, 500);
      };

      this.onDropdownMouseleave = () => {
        if (this.closeOnMouseleave) {
          this.close();
        }
      };

      this.close = () => {
        this.closeTimeout = $timeout(() => {
          this.opened = false;
          this.closeTimeout = null;

          $timeout.cancel(this.settingsMenuViewedTimeout);
          this.settingsMenuViewedTimeout = null;
        }, 200);
      };

      this.recordNavClick = (url: string) => {
        this.close();
        TrackingService.recordEvent(
          TrackingService.CATEGORY_NAVIGATION3,
          TrackingService.ACTION_NAVIGATION3_SETTINGS_DROPDOWN,
          url,
        );
      };

      this.onLogoutClicked = async () => {
        this.recordNavClick('/logout');
        // We use global signout for the "Logout" action now because Cognito fails to invalidate sessions otherwise.
        // This has the unfortunate side effect of logging the user out on all other devices.
        try {
          await AmplifyService.Auth.signOut({ global: true });
        } catch (e) {
          const err = e as { code: string | undefined } | undefined;

          if (err && err.code === 'NotAuthorizedException') {
            // The user's session has already expired or been revoked, and thus they can't "globally sign out"
            // Swallow this error and continue on.
          } else {
            // Record unexpected signout errors
            $log.warn('Global logout failed!', e);
          }
          // Fallback to a normal signout to clear session storage.
          AmplifyService.Auth.signOut();
        }
      };
    },
  ],
});
